'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isChangeMeaningful = exports.getAllChangedElements = exports.parseChangingUsers = exports.describeChangedElements = exports.parseChangedElementTypes = exports.describeElementTypes = exports.reduceTypeCounts = undefined;

var _lodash = require('lodash');

var _stringUtil = require('../utils/stringUtil');

var _immutableHelper = require('../utils/immutableHelper');

var _elementRegistry = require('../elements/elementRegistry');

var _elementConstants = require('../elements/elementConstants');

var ACTION_TYPES = _interopRequireWildcard(_elementConstants);

var _aliasConstants = require('../alias/aliasConstants');

var _boardConstants = require('../boards/boardConstants');

var _notificationConstants = require('./notificationConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// ----------------------
// Turn an array of [{ elementType: 'BOARD' }, { elementType: 'BOARD' }, { elementType: 'CARD' }, { elementType: 'LINK' }]
// into a map of { BOARD: 2, CARD: 1, LINK: 1 }
// ----------------------
var reduceTypeCounts = exports.reduceTypeCounts = function reduceTypeCounts(acc, change) {
    var type = (0, _immutableHelper.prop)('elementType', change) === _aliasConstants.ALIAS_TYPE ? _boardConstants.BOARD_TYPE : (0, _immutableHelper.prop)('elementType', change);
    var count = acc[type] || 0;
    acc[type] = count + 1;
    return acc;
};

// ----------------------
// Describe a map of { BOARD: 2, CARD: 1, LINK: 1 }
// as "2 boards, 1 note and 1 link"
// ----------------------


// Element Registry
var describeElementTypes = exports.describeElementTypes = function describeElementTypes(elementTypeChanges) {
    var typesArray = Object.keys(elementTypeChanges).sort();

    return typesArray.filter(function (type) {
        return elementTypeChanges[type] > 0;
    }).reduce(function (acc, type, i, self) {
        var count = elementTypeChanges[type];
        var typeName = (0, _elementRegistry.getElementDisplayName)(type).toLowerCase();
        var name = (0, _stringUtil.pluralise)(typeName, count);
        var separator = (0, _stringUtil.listSeparator)(i, self.length);
        return '' + acc + count + ' ' + name + separator;
    }, '');
};

// ----------------------
// Turn an array of [{ elementType: 'CARD', message: 'CREATED' }, { elementType: 'BOARD', message: 'UPDATED' }, { elementType: 'CARD', message: 'UPDATED' }]
// into a map of { created: { CARD: 1 }, updated: { BOARD: 1, CARD: 1 } }
// ----------------------
var parseChangedElementTypes = exports.parseChangedElementTypes = function parseChangedElementTypes(changes) {
    var newElements = changes.filter(function (change) {
        return change.message === _notificationConstants.MODIFIED_ELEMENTS_MESSAGES.CREATED;
    }).reduce(reduceTypeCounts, {});

    var updatedElements = changes.filter(function (change) {
        return change.message === _notificationConstants.MODIFIED_ELEMENTS_MESSAGES.UPDATED;
    }).reduce(reduceTypeCounts, {});

    return {
        created: newElements,
        updated: updatedElements
    };
};

// ----------------------
// Describe a map of { created: { CARD: 1 }, updated: { BOARD: 1, CARD: 1 } }
// as "created 1 card and updated 1 board and 1 card"
// ----------------------
var describeChangedElements = exports.describeChangedElements = function describeChangedElements(changesData) {
    var hasNew = Object.keys(changesData.created).length > 0;
    var hasUpdated = Object.keys(changesData.updated).length > 0;

    var describeNew = hasNew ? 'created ' + describeElementTypes(changesData.created) : '';

    var describeUpdated = hasUpdated ? 'updated ' + describeElementTypes(changesData.updated) : '';

    var separator = hasNew && hasUpdated ? ' and ' : '';

    return '' + describeNew + separator + describeUpdated;
};

// ----------------------
// Describe an array of [{ modifiedBy: 'abc' }, { modifiedBy: 'xyz' }, { modifiedBy: 'abc' }, { modifiedBy: 'jkl' }]
// as "Isaac Williams, Glenn Allen and Ollie Campbell"
// ----------------------
var parseChangingUsers = exports.parseChangingUsers = function parseChangingUsers(changes, users) {
    return changes.map(function (change) {
        return change.modifiedBy;
    }).filter(function (userId, i, self) {
        return self.indexOf(userId) === i;
    }).map(function (userId) {
        return users[userId];
    }).map(function (user) {
        return user.name.displayName;
    }).reduce(function (acc, name, i, self) {
        return acc + name + (0, _stringUtil.listSeparator)(i, self.length);
    }, '');
};

var getAllChangedElements = exports.getAllChangedElements = function getAllChangedElements(changedBoards) {
    return changedBoards.reduce(function (acc, board) {
        return acc.concat(board.children);
    }, []);
};

// ----------------------
// The following take an element action & decide whether it is
// a meaningful change or not
// ----------------------

var isMoveMeaningful = function isMoveMeaningful(action, move) {
    if (!move.from) return false;
    if (move.location.parentId !== move.from.parentId) return true;
    if (move.location.section !== move.from.section) return true;

    if (move.location.section === _boardConstants.BOARD_SECTIONS.INBOX) {
        var index = (0, _lodash.get)(move, ['location', 'position', 'index'], 0);
        var indexFrom = (0, _lodash.get)(move, ['from', 'position', 'index'], index);
        var distanceMoved = Math.abs(index - indexFrom);
        return distanceMoved >= _notificationConstants.INBOX_MOVE_MEANINGFUL_DIST;
    }

    var pos = (0, _lodash.get)(move, ['location', 'position'], { x: 0, y: 0 });
    var posFrom = (0, _lodash.get)(move, ['from', 'position'], pos);

    var dx = pos.x - posFrom.x;
    var dy = pos.y - posFrom.y;
    var distanceMovedSqrd = dx * dx + dy * dy;

    return distanceMovedSqrd >= _notificationConstants.CANVAS_MOVE_MEANINGFUL_DIST_SQRD;
};

var isUpdateMeaningful = function isUpdateMeaningful(action) {
    var updates = action.updates;

    if (!updates) return false;

    var changeKeys = (0, _lodash.flatMap)(updates, function (update) {
        return Object.keys(update.changes);
    });
    var changeList = (0, _lodash.intersection)(changeKeys, _notificationConstants.UPDATE_MEANINGFUL_CHANGE_KEY_LIST);

    return changeList.length > 0;
};

var isChangeMeaningful = exports.isChangeMeaningful = function isChangeMeaningful(action, data) {
    switch (action.type) {
        case ACTION_TYPES.ELEMENT_CREATE:
        case ACTION_TYPES.ELEMENT_SHARE:
        case ACTION_TYPES.ELEMENT_UNSHARE:
            return true;
        case ACTION_TYPES.ELEMENT_MOVE_MULTI:
            return isMoveMeaningful(action, data);
        case ACTION_TYPES.ELEMENT_UPDATE:
            return isUpdateMeaningful(action);
        default:
            return false;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/common/notifications/notificationUtils.js
// module id = 324
// module chunks = 0